import axios from "axios";
import { autoLogout } from "../utils/logoutHelper";

// Centralized axios instance for all admin API calls.
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_URL,
  headers: {
    "X-Requested-With": "XMLHttpRequest",
  },
});

// Request interceptor: attach the token fresh on every request.
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("Token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
      config.headers["J-authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor: on 401, clear session and redirect to login.
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      autoLogout("/");
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
